import React from 'react';
import { IconPlus, IconTrash } from '@tabler/icons-react';

import { ConversationItem } from '../../@types/chat';
import { Button, Icon } from '../IDSK';
import { formatDate } from '../../utils/format-date';
import Confirmation from '../Confirmation';

interface ConversationListProps {
    conversations: ConversationItem[];
    activeConversation: string | null;
    hasMore: boolean;
    onSelect: (conversationId: string) => void;
    onNewChat: () => void;
    onClose: (conversationId: string) => void;
    onLoadMore: () => void;
}

export default function ConversationList(props: ConversationListProps) {
    return <>
        <div className="chat--conversation-list">
            <div className="chat--conversation-list--header">
                <Button onClick={props.onNewChat} className="chat--conversation-list--new-button">
                    <IconPlus /> Nová konverzácia
                </Button>
            </div>

            <div className="chat--conversation-list--items">
                {props.conversations.map((conv) => (
                    <div
                        key={conv.id}
                        className={`chat--conversation-list--item ${props.activeConversation === conv.id ? 'chat--conversation-list--item--active' : ''}`}
                        onClick={() => props.onSelect(conv.id)}
                    >
                        <div className={`chat--conversation-list--item--title ${!conv.title ? 'no-title' : ''}`}>
                            {conv.title || 'Nová konverzácia'}
                        </div>
                        <div className="chat--conversation-list--item--date">
                            {formatDate(conv.date)}
                        </div>

                        <Confirmation
                            onConfirm={() => props.onClose(conv.id)}
                            label="Naozaj chcete vymazať túto konverzáciu? Operácia je nenávratná"
                            className="chat--conversation-list--item--close"
                        >
                            <Icon className="chat--popup--close" title="Vymazať">
                                <IconTrash />
                            </Icon>
                        </Confirmation>
                    </div>
                ))}

                {props.conversations.length === 0 && (
                    <div className="chat--conversation-list--empty">
                        Žiadne konverzácie
                    </div>
                )}

                {props.hasMore && (
                    <button className="chat--conversation-list--load-more" onClick={props.onLoadMore}>
                        Načítať viac
                    </button>
                )}
            </div>
        </div>
    </>;
}
